<template>
  <v-dialog
    v-model="dialogShow"
    scrollable
    persistent
    max-width="560"
    @keydown.esc="cancel"
  >
    <v-card
      color="lightPrimary help-and-support-modal help-and-support-modal--mobile"
    >
      <div class="d-flex flex-row">
        <div class="image-container">
          <img
            class="hidden--mobile"
            :src="require('../assets/ondivan_marca_red.svg')"
            width="124px"
          />
          <img
            :src="require('../assets/close.svg')"
            width="20px"
            style="cursor: pointer"
            @click="toggleModalView()"
          />
          <!-- :src="require('../../assets/close-circle.svg')" -->
        </div>
      </div>
      <img
        class="logo--mobile"
        :src="require('../assets/ondivan_marca_red.svg')"
        width="124px"
      />
      <span class="text-h6 primary--text d-flex font-weight-medium">
        Central de Ajuda e Suporte
      </span>
      <div class="d-flex flex-column mt-2 pb-0">
        <p class="gray--text font-weight-regular">
          Está com alguma dúvida ou precisa de suporte aqui na plataforma ?
        </p>
        <p class="gray--text font-weight-regular">
          Mande seu questionamento para:
          <a href="mailto: suporte@ondivan.com"> suporte@ondivan.com </a> ou
          envie uma mensagem para o Chatbot que iremos auxiliar no que for
          preciso.
        </p>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.help-and-support-modal {
  border-radius: 10px !important;
  background-color: white !important;
  padding: 26px 52px;
}
.image-container {
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.logo--mobile {
  display: none;
}
@media screen and (max-width: 420px) {
  .hidden--mobile {
    visibility: hidden;
  }
  .logo--mobile {
    display: block;
    align-self: center;
    margin-bottom: 16px;
  }
  .help-and-support-modal--mobile {
    padding: 20px 40px;
    text-align: center;
  }
  .image-container {
    margin-bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>


<script>
export default {
  data: () => ({
    dialogShow: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 290,
    },
  }),
  mounted() {
    const statusFromHelpCenter = window.localStorage.getItem(
      '@ondivan/helpCenterDialog',
    );
    this.dialogShow = statusFromHelpCenter !== 'read';
  },
  methods: {
    toggleModalView() {
      this.dialogShow = !this.dialogShow;
      if (!this.dialogShow) {
        window.localStorage.setItem('@ondivan/helpCenterDialog', 'read');
      }
    },
  },
};
</script>
